import { __extends } from "tslib";
import { Event } from './Event';
var ShaderEvent = /** @class */ (function (_super) {
    __extends(ShaderEvent, _super);
    function ShaderEvent(type, bubbles, cancelable, bitmap, array, vector) {
        if (bubbles === void 0) { bubbles = false; }
        if (cancelable === void 0) { cancelable = false; }
        if (bitmap === void 0) { bitmap = null; }
        if (array === void 0) { array = null; }
        if (vector === void 0) { vector = null; }
        return _super.call(this, type, bubbles, cancelable) || this;
    }
    ShaderEvent.classInitializer = null;
    ShaderEvent.classSymbols = null;
    ShaderEvent.instanceSymbols = null;
    // JS -> AS Bindings
    ShaderEvent.COMPLETE = 'complete';
    return ShaderEvent;
}(Event));
export { ShaderEvent };
